var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer_icon",
    transform: "translate(0.113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 96,
    height: 96,
    rx: 12,
    transform: "translate(-0.113)",
    fill: "#fdf5e9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "corporate_fare_black_24dp",
    transform: "translate(21 21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1135",
    "data-name": "Rectangle 1135",
    width: 54,
    height: 54,
    transform: "translate(-0.113)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    d: "M24.5,12V7.5A4.513,4.513,0,0,0,20,3H6.5A4.513,4.513,0,0,0,2,7.5V39a4.513,4.513,0,0,0,4.5,4.5h36A4.513,4.513,0,0,0,47,39V16.5A4.513,4.513,0,0,0,42.5,12ZM20,39H6.5V34.5H20Zm0-9H6.5V25.5H20Zm0-9H6.5V16.5H20Zm0-9H6.5V7.5H20ZM42.5,39h-18V16.5h18ZM38,21H29v4.5h9Zm0,9H29v4.5h9Z",
    transform: "translate(2.5 3.75)",
    fill: "#eb9929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customer_icon.086f5f839829491045957940a6d1f3a3.svg";
export { ForwardRef as ReactComponent };